import React from 'react';

import {
  BannerWrapper,
  BannerSkeleton,
  CategoriesWrapper,
  CategoriesWrapperShift,
  CategoriesHeader,
  CategoriesHeading,
  CategoriesSliderContainer,
  CategoriesViewport,
  CategoriesItems,
  CategoryCardSkeleton,
} from './placeholder-content.styles';

/**
 * Renders a placeholder for the MenuImageBanner component.
 * Matches the 3:1 aspect ratio on desktop and 2.22:1 on mobile.
 */
export const PlaceholderMenuImageBanner = (): JSX.Element => (
  <BannerWrapper data-testid='placeholder-menu-image-banner'>
    <BannerSkeleton aria-hidden='true' />
  </BannerWrapper>
);

/**
 * Renders a placeholder for the CategoriesNav component.
 * Shows a heading skeleton and multiple category card skeletons in a horizontal layout.
 */
export const PlaceholderCategoriesNav = (): JSX.Element => (
  <CategoriesWrapper data-testid='placeholder-categories-nav'>
    <CategoriesWrapperShift>
      <CategoriesHeader>
        <CategoriesHeading aria-hidden='true' />
      </CategoriesHeader>

      <CategoriesSliderContainer>
        <CategoriesViewport>
          <CategoriesItems>
            <CategoryCardSkeleton aria-hidden='true' />
            <CategoryCardSkeleton aria-hidden='true' />
            <CategoryCardSkeleton aria-hidden='true' />
            <CategoryCardSkeleton aria-hidden='true' />
            <CategoryCardSkeleton aria-hidden='true' />
            <CategoryCardSkeleton aria-hidden='true' />
            <CategoryCardSkeleton aria-hidden='true' />
          </CategoriesItems>
        </CategoriesViewport>
      </CategoriesSliderContainer>
    </CategoriesWrapperShift>
  </CategoriesWrapper>
);
